// extracted by mini-css-extract-plugin
export default {"container":"table_container__2faDn","tableWrapper":"table_tableWrapper__uykdD","row":"table_row__vEU5g","red":"table_red__4RPaK","green":"table_green__mAPYm"};